<script>
import { mapGetters } from "vuex";
import { Modal } from "uiv";

export default {
  components: { Modal },
  computed: {
    ...mapGetters([
      "isMaster",
      "isPreloader",
      "getFichaCodigo",
      "getFichaConector",
    ]),
    mostrar() {
      return this.getFichaCodigo !== "" && this.getFichaConector !== "";
    },
  },
};
</script>

<template>
  <modal
    v-model="mostrar"
    :header="false"
    :footer="false"
    :append-to-body="true"
    class="preloader-modal"
  >
    <div class="panel-body">
      <div class="progress">
        <div class="progress-bar progress-bar-striped active" style="width: 60%"></div>
      </div>
    </div>
    <div class="panel-body">
      <div class="lead text-center">Se esta buscando disponibilidad para el circuito solicitado.</div>
    </div>
  </modal>
</template>

<style lang="scss" scoped>
.panel-body {
  padding: 30px 20px;
  overflow: hidden;

  &:first-child {
    background: #2c3e50;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  &:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .progress {
    margin: 0;
  }
  .lead {
    margin: 0;
  }
}
</style>